import { render } from "./FullPopup.vue?vue&type=template&id=6423c42c&scoped=true"
import script from "./FullPopup.vue?vue&type=script&lang=js"
export * from "./FullPopup.vue?vue&type=script&lang=js"

import "./FullPopup.vue?vue&type=style&index=0&id=6423c42c&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6423c42c"]])

export default __exports__